// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"InfoBusinessCardWrapper_cardBody__P54oj","cardWithSeparator":"InfoBusinessCardWrapper_cardWithSeparator__TKZsQ"};